import { render, staticRenderFns } from "./exchange-add.vue?vue&type=template&id=d6cdb638&scoped=true&"
import script from "./exchange-add.vue?vue&type=script&lang=js&"
export * from "./exchange-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=d6cdb638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cdb638",
  null
  
)

component.options.__file = "exchange-add.vue"
export default component.exports